module.exports = __webpack_public_path__ + "img/powered-safety.90737d47.svg";